module.exports = __webpack_public_path__ + "assets/img/thumb-Gourmet-Basket-eBook.159bc5f8.png";